import { FileTypes } from "./fileutils";

export interface UploadProgress {
  totalSize: number;
  uploaded: number;
}

export const getAcceptForFileType = (fileType: Exclude<FileTypes, "unknown">) => {
  switch (fileType) {
    case "image":
      return {
        "image/*": [".png", ".jpg", ".jpeg", ".pjpeg", ".bmp"],
      };
    case "docx":
      return {
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
      };
    case "pdf":
      return {
        "application/pdf": [".pdf"],
      };
    default:
      return undefined;
  }
}

export const getHtmlAcceptForFileType = (fileType: Exclude<FileTypes, "unknown">) => {
  switch (fileType) {
    case "image":
      return "image/*,.png,.jpg,.jpeg,.pjpeg,.bmp";
    case "pdf":
      return "application/pdf,.pdf";
    case "docx":
      return "application/vnd.openxmlformats-officedocument.wordprocessingml.document,.docx";
    default:
      return undefined;
  }
}

export const getIconTypeForFileType = (fileType: Exclude<FileTypes, "unknown">) => {
  switch (fileType) {
    case "image":
      return "image";
    case "pdf":
      return "pdf";
    case "docx":
      return "docx";
    default:
      return "file";
  }
}